<template>

     <div class="row mx-0 justify-content-center">
    
       <div class="col-lg-6 text-center  col-lg-6 col-md-6 col-10 pt-2 login-img">
        <a class="llp-logo" href="/">
          <img :alt="Logo" :aria-label="Logo" src="/images/makbilllogo.png" class="img-fluid1" />
        </a>
      </div>
   <div class="col-lg-6  col-md-6 col-sm-6  d-flex justify-content-center align-items-center">
    <form class="d-grid" @submit.prevent="doForgotPassword">
       <div class="row justify-content-center p-2">
                  <h4 class="otp-heading">Forgot Password</h4>
                </div>
              <div class="mb-3">
                <llp-label id="email" :aria-label="Email">Email:</llp-label>
                <llp-input
                  id="email"
                  v-model:modelValue="credential.email"
                  :errors="validator.credential.email.$errors"
                ></llp-input>
              </div>
              <div class="mb-3 d-flex align-items-center">
                <llp-label id="captcha" :aria-label="Captcha" class="me-2"
                  >Captcha:</llp-label
                >
                <div v-if="isCaptchaLoading" class="captcha-loader me-2">
                  <i class="fas fa-spinner fa-spin"></i>
                </div>
                <img
                  v-else
                  :src="captchaImage"
                  alt="CAPTCHA"
                  class="img-fluid me-2"
                  style="max-width: 100%"
                />
                <button
                  type="button"
                  @click="refreshCaptcha"
                  class="btn btn-link"
                  aria-label="Refresh CAPTCHA"
                  title="Refresh CAPTCHA"
                >
                  <i class="fas fa-sync-alt"></i></button
                ><br />
                <llp-input
                  id="captcha"
                  v-model:modelValue="credential.captcha"
                  :errors="validator.credential.captcha.$errors"
                  class="w-100"
                  autocomplete="off"
                  style="min-width: 100px"
                ></llp-input>
              </div>
              <div class="mb-3">
                <p v-if="errorMessage" class="text-danger">{{ errorMessage }}</p>
              </div>

              <div class="mb-3 text-center">
                <llp-button
                  :loadSpinner="showSpinner"
                  classNames="btn-secondary"
                  type="submit"
                  :disabled="isButtonDisabled" 
                  >Reset</llp-button
                >
              </div>
              <div class="row justify-content-center p-2">
                <llp-button
                  classNames="btn-link text-decoration-none new-btn"
                  type="button"
                  @click:button="goToLogin"
                >
                  Back to Login
                </llp-button>
              </div>
            </form>
   </div>
   <llp-toast ref="toast"></llp-toast>
          </div>
       
     
  
 
</template>


<script>
import { helpers, required } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
// import ErrorService from '../../services/error.service';
import NetworkService from "../../services/network.service";
import axios from "axios";
export default {
  name: "ForgotPasswordPage",
  setup: () => ({ validator: useVuelidate() }),
  data() {
    return {
      credential: {
        email: "",
        captcha: "",
      },
      errorMessage: null,
      showSpinner: false,
      isCaptchaLoading: false,
      isButtonDisabled:false
    };
  },
  validations() {
    return {
      credential: {
        email: {
          required: helpers.withMessage("Email is a required field", required),
          validFormat: helpers.withMessage(
    "Please enter a valid email address.",
    (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
  )
        },
        captcha: {
          required: helpers.withMessage("CAPTCHA is required.", required),
        },
      },
    };
  },
  methods: {
    async doForgotPassword() {
      this.errorMessage = "";
      this.validator
        .$validate()
        .then(async (isValid) => {
          // Validate email field
          if (!isValid) return Promise.reject();
          this.showSpinner = true;
          const data = {
              email: this.credential.email,
              captcha: this.credential.captcha,
              key: this.captchaKey,
            }
          try {
           const response = await NetworkService.post("/forget-password", data);
        if (response.data.message) {
          this.$refs.toast.show(response.data.message);

          this.errorMessage = "";
           this.isButtonDisabled = true; 
        } else {
          this.errorMessage = response.message;
        }
            setTimeout(() => {
              this.showSpinner = false;
            }, 2000);
          } catch (error) {
            this.showSpinner = false;
            this.errorMessage = error.message;
             this.isButtonDisabled = false; 
            await this.refreshCaptcha();
          }
        })
        .catch(() => {
           this.showSpinner = false;
            this.isButtonDisabled = false; 
        });
    },
    async refreshCaptcha() {
      this.isCaptchaLoading = true;
      this.credential.captcha = "";
      try {
        // const response = await NetworkService.get('default');
     // const response = await axios.get(
      //    "https://efarmers.live/makbill/public/captcha/api/default"
      //  );
         const response = await axios.get(
          "https://connect.makbill.com/captcha/api/default"
        );
        this.captchaImage = response.data.img;
        this.captchaKey = response.data.key;
      } catch (error) {
        this.messages = "Failed to load CAPTCHA. Please try again.";
      } finally {
        this.isCaptchaLoading = false;
      }
    },
    goToLogin() {
      this.$router.push("/");
    },
  },

  async mounted() {
    await this.refreshCaptcha();
  },
};
</script>

